import { Navigate, useLocation } from 'react-router-dom'

import { featureForPath, isStudioPortalEnabled } from '@/constants/tenant-features'
import { PUBLIC_NAV_ITEMS, firstVisiblePublicNavPath } from '@/constants/user-menu'
import { usePortalVisibility, useTenantFeatures } from '@/hooks'

/** 未开通模块或关闭门户入口的路由重定向 */
export function TenantFeatureGuard({ children }: { children: React.ReactNode }) {
  const { pathname } = useLocation()
  const { features, isEnabled, loading } = useTenantFeatures()
  const { isPortalEnabled, loading: portalLoading } = usePortalVisibility()

  const requiredFeature = featureForPath(pathname)
  const fallback = firstVisiblePublicNavPath(PUBLIC_NAV_ITEMS, isEnabled, isPortalEnabled)

  if (loading || portalLoading) {
    return <>{children}</>
  }

  const onHome = pathname === '/' || pathname === ''
  if (onHome && !isPortalEnabled('nav.home')) {
    return <Navigate to={fallback} replace />
  }

  if (pathname.startsWith('/works') && !isPortalEnabled('nav.works')) {
    return <Navigate to={fallback} replace />
  }

  if (pathname.startsWith('/studio') && !isStudioPortalEnabled(features)) {
    return <Navigate to={fallback} replace />
  }

  if (requiredFeature && !isEnabled(requiredFeature)) {
    return <Navigate to={fallback} replace />
  }

  return <>{children}</>
}
